import { render, staticRenderFns } from "./form3.vue?vue&type=template&id=5bdecf13&scoped=true"
import script from "./form3.vue?vue&type=script&lang=js"
export * from "./form3.vue?vue&type=script&lang=js"
import style0 from "./form3.vue?vue&type=style&index=0&id=5bdecf13&prod&lang=scss&scoped=true"
import style1 from "./form3.vue?vue&type=style&index=1&id=5bdecf13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdecf13",
  null
  
)

export default component.exports